import classNames from 'classnames';
import { FlexContainer, Txt } from 'components';
import {
  privacyPolicyLink,
  propaLandingLink,
  supportLinkSite,
  termsAndConditionsLink,
} from 'config';
import styles from './AuthSidePresentation.module.scss';

/**
 * AuthSidePresentation
 *
 * @return {JSX.Element}
 */
const AuthSidePresentation = ({ className }) => {
  return (
    <FlexContainer
      flex
      className={classNames(
        styles.AuthSidePresentation,
        className,
        AuthSidePresentation.displayName
      )}
      justifyContentEnd
      column
    >
      <FlexContainer className={styles.Footer} column gapHalf>
        <Txt xx>
          <a href={propaLandingLink} target="_blank" rel="noreferrer">
            Propa
          </a>
          &nbsp; -&nbsp;
          <a href={supportLinkSite} target="_blank" rel="noreferrer">
            Support
          </a>{' '}
          &nbsp;-&nbsp;
          <a href={privacyPolicyLink} target="_blank" rel="noreferrer">
            Privacy policy
          </a>{' '}
          &nbsp;- &nbsp;
          <a href={termsAndConditionsLink} target="_blank" rel="noreferrer">
            Terms and conditions
          </a>
        </Txt>
        <Txt regular>
          Copyright © 2022 Propa Software Ltd. All rights reserved. Propa is a
          trademark of Propa Software Ltd a company registered in the UK.
          Registration no: 12287067.
          <br />‍<br />
          Photo by Burçin Ergünt
        </Txt>
      </FlexContainer>
    </FlexContainer>
  );
};

AuthSidePresentation.displayName = 'AuthSidePresentation';

export default AuthSidePresentation;
